import React, { FC, useEffect, useState } from 'react'
import { BasicStatsItem } from './index.styles'
import { Text } from '../text.component'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { OBLAST_KATO } from '../../constants/snp.constant'
import { INewBudgetData, INewBudgetItem } from './right-menu.component'

export const NewBudgetTable = styled.table`
  width: 100%;
  border-collapse: collapse;  
  height: 100%;
  text-align: center;
  table-layout: auto; 
  padding-top: 1rem;

  tbody {
    tr td:first-child {
      text-align: left;
    }
  }

  tr td:last-child,
  tr th:last-child {
    border-right: none;
  }

  th,
  td {
    border-bottom: 1px solid var(--borderGray);
    border-right: 1px solid var(--borderGray);
    padding: 0.5rem;
    vertical-align: middle;
  }

  th {
    vertical-align: top;
  }

  .clickable {
    cursor: pointer;
    text-decoration: underline;
    font-weight: 400;
  }
  `;

interface IProps {
  kato: string;
  handleClick: (name: string) => void;
  data: INewBudgetData;
}

const tableHeaders: (keyof INewBudgetItem)[] = [
  'districtOrAdministator',
  'plan2025',
  'planOnFeb28',
  'executedOnFeb28',
  'executionPercentage',
  'remaining',
]

const nameToKey: Record<string, string> = {
  'Районы и города': 'regions-and-cities',
  'Собственно-областной': "regional"
}

const isClickable = (name: string) => ['Районы и города', 'Собственно-областной'].includes(name)

const NewBudget: FC<IProps> = ({ kato, handleClick, data }) => {
  const { t } = useTranslation()
  const [tableBody, setTableBody] = useState<INewBudgetItem[]>([])

  const generateTableBody = () => {
    if (+kato === OBLAST_KATO) {
      const totalIndex = data.budgetExecutionCard.findIndex(item => item.districtOrAdministator === 'ИТОГО');
      if (totalIndex !== -1) {
        const totalItem = data.budgetExecutionCard.splice(totalIndex, 1)[0];
        totalItem.districtOrAdministator = 'Итоги';
        data.budgetExecutionCard.unshift(totalItem);
      }

      console.log(data.budgetExecutionCard)
      setTableBody(data.budgetExecutionCard)
    } else {
      const foundRegion = data.districtBudgetExecution.find(item => +item.katoOrCode === +kato)
      setTableBody(foundRegion ? [foundRegion] : [])
    }
  }

  const handleLinkClick = (name: string) => {
    name !== 'total' && handleClick(name)
  }

  useEffect(() => {
    data && generateTableBody()
  }, [kato, data])

  return (
    <BasicStatsItem>
      <div className="title with-icon">
        <div className="left">
          <Text color='var(--primary-color)' fontWeight={500} fontSize='0.875rem'>{t(`budgetInvestmentProjectStats.osvoenie`)}</Text>
        </div>
      </div>
      <div className="body">
        {data && <NewBudgetTable>
          <thead>
            <tr>
              {tableHeaders.map((header, index) => (
                <th key={index}>
                  <Text color='var(--shuttleGray)' fontWeight={400} fontSize='0.75rem'>{t(`new-budget.${header}`)}</Text>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {tableBody.map((row, row_index) => (
              <tr key={row_index}>
                {tableHeaders.map((header, index) => (
                  header === 'districtOrAdministator' ?
                    <td key={header} onClick={() => isClickable(row[header]) && handleLinkClick(nameToKey[row[header]])}>
                      <Text className={!isClickable(row[header]) ? '' : 'clickable'} color='var(--text-color)' fontWeight={700} fontSize='0.75rem'>{row[header]}</Text>
                    </td> :
                    <td key={header}>
                      <Text color='var(--primary-color)' fontWeight={row_index !== 0 ? 400 : 700} fontSize='0.75rem'>{row[header].toLocaleString('Ru')}</Text>
                    </td>
                ))}
              </tr>
            ))}
          </tbody>
        </NewBudgetTable>}
      </div>
    </BasicStatsItem>
  )
}

export default NewBudget